import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Sheet from '@mui/joy/Sheet'
import IconButton from '@mui/joy/IconButton'
import Remove from '@mui/icons-material/Remove'
import Add from '@mui/icons-material/Add'

const MinusButton = ({ onClick }) => (
    <IconButton variant="soft" onClick={onClick}>
        <Remove />
    </IconButton>
)

const AddButton = ({ onClick }) => (
    <IconButton variant="soft" onClick={onClick}>
        <Add />
    </IconButton>
)

export const NumberInput = ({
    value,
    label,
    step = 1,
    min,
    max,
    onChange,
    styles,
}) => {
    const handleOnChange = (e) => {
        onChange(Number(e.target.value))
    }

    const stepUp = () => {
        let next = value + step
        if (next > max) {
            return
        }
        onChange(next)
    }

    const stepDown = () => {
        let next = value - step
        if (next < min) {
            return
        }
        onChange(next)
    }

    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <Sheet
                variant="outlined"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    borderRadius: 6,
                }}
            >
                <MinusButton onClick={stepDown} />
                {value}
                <AddButton onClick={stepUp} />
            </Sheet>
        </FormControl>
    )
}
